export const BOOKING_THEME_IDS = Object.freeze([
  "pilcore-light",
  "editorial",
  "premium-dark",
]);

const BOOKING_THEME_SET = new Set(BOOKING_THEME_IDS);

export const BOOKING_THEME_SWATCHES = Object.freeze({
  "pilcore-light": ["#F4F8FB", "#223A7A", "#3DB6E9", "#63C1C7"],
  editorial: ["#FCFAF7", "#20283A", "#246B68", "#C8A978"],
  "premium-dark": ["#10182B", "#17233D", "#3DB6E9", "#63C1C7"],
});

export function normalizeBookingTheme(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return BOOKING_THEME_SET.has(normalized) ? normalized : "pilcore-light";
}

export function applyBookingThemeToRoot(value, root) {
  const target = root || (typeof document !== "undefined" ? document.documentElement : null);
  if (!target) return () => {};

  const previous = target.getAttribute("data-booking-theme");
  target.setAttribute("data-booking-theme", normalizeBookingTheme(value));

  return () => {
    if (previous == null) {
      target.removeAttribute("data-booking-theme");
    } else {
      target.setAttribute("data-booking-theme", previous);
    }
  };
}

export function readBookingThemeCssTokens(root) {
  const target = root || (typeof document !== "undefined" ? document.documentElement : null);
  const styles =
    target && typeof window !== "undefined" && typeof window.getComputedStyle === "function"
      ? window.getComputedStyle(target)
      : null;
  const read = (name, fallback) => styles?.getPropertyValue(name)?.trim() || fallback;

  return {
    text: read("--be-text", "#223A7A"),
    muted: read("--be-text-muted", "#52617F"),
    error: read("--be-error", "#B42318"),
    surface: read("--be-input-bg", "#FFFFFF"),
    border: read("--be-control-border", "#6D829B"),
    font: read("--be-font-body", "Montserrat, system-ui, sans-serif"),
  };
}
